import PurchaseRequestType from '@/types/purchaseRequest/purchaseRequestType'
import { BaseService } from './../../base'
export class PurchaseRequestTypeService extends BaseService<PurchaseRequestType>() {
    static get entity (): string {
        return 'purchase_request_type'
    }
    static get responseName (): string {
        return 'purchase_request_type'
    }
}